import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { BaseService } from './base.services';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable()
export class NotificationService extends BaseService {

  constructor(private http: HttpClient,
    public toastr: ToastrService,
    private store: Store<any>) {
    super(toastr);
  }

  getNewNotification(accountId: number): Observable<any> {
    // const params = new HttpParams()
    //   .set('memberId', memberId.toString())
    //   .set('accountId', accountId.toString())
    //   .set('page', page.toString());
    return this.http.get(environment.apiUrl + `/member-portal/Notification/account/${accountId}/new-notifications`, { headers: this.headers() });
  }

  getNotification(accountId: number): Observable<any> {
    // const params = new HttpParams()
    //   .set('memberId', memberId.toString())
    //   .set('accountId', accountId.toString())
    //   .set('page', page.toString());
    return this.http.get(environment.apiUrl + `/member-portal/Notification/account/${accountId}/notifications`, { headers: this.headers() });
  }

}
